export default __webpack_public_path__ + "static/media/launch-home@3x.8f2f8d9e.png";